import { AuthorizationContext } from "../types/auth";

export type AccessRule = { anyOf?: string[]; allOf?: string[]; superAdmin?: boolean };

export function hasAccess(context: AuthorizationContext | null, rule: AccessRule): boolean {
  if (!context) return false;
  if (context.isSuperAdmin) return true;
  if (rule.superAdmin) return false;
  return (!rule.allOf || rule.allOf.every(key => context.permissionKeys.includes(key))) &&
    (!rule.anyOf || rule.anyOf.some(key => context.permissionKeys.includes(key)));
}

const policies: Array<[RegExp, AccessRule]> = [
  [/^\/dashboard\/?$/, { allOf: ["dashboard.read"] }],
  [/^\/customers(?:\/|$)/, { allOf: ["customers.read"] }],
  [/^\/shipments\/?$/, { anyOf: ["shipments.read", "shipping_rates.read"] }],
  [/^\/shipments\//, { allOf: ["shipments.read"] }],
  [/^\/quote-request(?:\/|$)/, { allOf: ["quotes.read"] }],
  [/^\/tracking(?:\/|$)/, { allOf: ["tracking.read"] }],
  [/^\/purchase-orders\/?$/, { anyOf: ["products.read", "orders.read"] }],
  [/^\/purchase-orders\//, { allOf: ["shop_requests.read"] }],
  [/^\/fooding-orders\//, { allOf: ["orders.read"] }],
  [/^\/product-details\//, { allOf: ["products.read"] }],
  [/^\/shop-with-link(?:\/|$)/, { allOf: ["shop_requests.read"] }],
  [/^\/naija-shop(?:\/|$)/, { anyOf: ["vendor_products.read", "orders.read"] }],
  [/^\/amazon(?:\/|$)/, { allOf: ["carts.read"] }],
  [/^\/vendors(?:\/|$)/, { allOf: ["vendors.read"] }],
  [/^\/(?:fx|exchange-rate)(?:\/|$)/, { allOf: ["exchange_rates.read"] }],
  [/^\/transactions(?:\/|$)/, { allOf: ["transactions.read"] }],
  [/^\/support(?:\/|$)/, { allOf: ["support_tickets.read"] }],
  [/^\/user-management(?:\/|$)/, { superAdmin: true }],
  [/^\/(?:audit|settings|profile-upload)\/?$/, {}],
];

export function canVisit(path: string, context: AuthorizationContext | null): boolean {
  const policy = policies.find(([pattern]) => pattern.test(path));
  return !!policy && hasAccess(context, policy[1]);
}

export function defaultRoute(context: AuthorizationContext | null): string {
  const candidates = ["/dashboard", "/customers", "/shipments", "/purchase-orders", "/naija-shop", "/support", "/transactions", "/fx", "/tracking", "/shop-with-link", "/amazon", "/quote-request", "/vendors"];
  return candidates.find(path => canVisit(path, context)) || "/profile-upload";
}
